import React, { useEffect, useState } from "react";
import { supabase } from "..";
import { Navigate, Outlet, useNavigate, useParams } from "react-router-dom";
import { activeSubscription } from "../services/paymentService";

import { website_url } from "../bootapi";
const journalPaths = [
  "/addjournalentry",
  "/addjournalgratitude",
  "/myjournal",
  "/journalsummary",
  "/journalgoodhabit",
  "/journalgoals",
  "/journalsetting",
];
const arcPaths = ["/startmaintest"];
const checkPath = (pathAfterAuth) => {
  if (
    journalPaths.includes(pathAfterAuth) ||
    arcPaths.includes(pathAfterAuth)
  ) {
    return true;
  }
};

const Protected = () => {
  const history = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { refresh_session } = useParams();
  const [activePlans, setActivePlans] = useState(null);
  const [planSuccess, setPlanSuccess] = useState(true);
  const [shouldRenderOutlet, setShouldRenderOutlet] = useState(false);

  const checkSubscriptionAndRedirect = (arr, pathAfterAuth) => {
    const trueStatusArray = [];
    const subscriptionsToCheck = [
      "SeventhArc",
      "SeventhGuide",
      "SeventhSight",
      "seventhjournal",
    ];

    subscriptionsToCheck.forEach((property) => {
      // Check if the property exists and has a true value
      arr.forEach((subs) => {
        if (subs[property] === true) {
          // Store the property name in the array
          trueStatusArray.push(property);
        }
      });
    });

    // Check if SeventhJournal is in the true status array
    if (
      !trueStatusArray.includes("seventhjournal") &&
      journalPaths.includes(pathAfterAuth)
    ) {
      history("/create_subscription", {
        state: {
          planType: {
            planName: "SeventhJournal",
            status: false,
          },
        },
      });
      setPlanSuccess(false);
    }
    if (
      !trueStatusArray.includes("SeventhArc") &&
      arcPaths.includes(pathAfterAuth)
    ) {
      history("/create_subscription", {
        state: {
          planType: {
            planName: "SeventhArc",
            status: false,
          },
        },
      });
      setPlanSuccess(false);
    } else {
      setShouldRenderOutlet(true);
    }
  };

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const session = await supabase.auth.getSession();
        const currentURL = window.location.href;
        const dynamicPart = currentURL.replace(`${website_url}/`, "");
        // console.log(dynamicPart);

        const pathAfterAuth = currentURL.split("/auth")[1];
        if (session.data.session !== null) {
          setIsAuthenticated(true);
          directToPaymentUpdate(
            dynamicPart,
            session.data.session.refresh_token
          );

          if (checkPath(pathAfterAuth)) {
            getActivePlans(
              session.data.session.user.id,
              session.data.session.access_token,
              pathAfterAuth
            );
          } else {
            setShouldRenderOutlet(true);
          }
        } else {
          if (refresh_session) {
            const res = await supabase.auth.refreshSession({
              refresh_token: refresh_session,
            });

            if (res && res.data && res.data.session) {
              directToPaymentUpdate(
                dynamicPart,
                res.data.session.refresh_token
              );
              if (checkPath(pathAfterAuth)) {
                getActivePlans(
                  res.data.session.user.id,
                  res.data.session.access_token,
                  pathAfterAuth
                );
              } else {
                setShouldRenderOutlet(true);
              }
              setIsAuthenticated(true);
            } else {
              localStorage.removeItem("sevensight_user");
              setIsAuthenticated(false);
              if (dynamicPart) {
                history(`/signin?redirect=${encodeURIComponent(dynamicPart)}`);
              } else {
                history("/signin");
              }
              // console.log("104");
            }
          } else {
            localStorage.removeItem("sevensight_user");
            setIsAuthenticated(false);
            history(`/signin?redirect=${encodeURIComponent(dynamicPart)}`);
            // console.log("110");
          }
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
      }
    };

    const getActivePlans = (user_id, token, pathAfterAuth) => {
      activeSubscription(user_id, token)
        .then((res) => {
          if (res.data.status) {
            let arr = [];
            Object.keys(res.data.Subscriptions).forEach((i) => {
              if (res.data.Subscriptions[i]) {
                arr.push(res.data.Subscriptions[i]);
              }
            });
            setActivePlans(arr);

            if (arr.length > 0) {
              checkSubscriptionAndRedirect(arr, pathAfterAuth);
            } else {
              setShouldRenderOutlet(true);
            }
          }
        })
        .catch((err) => {
          history("/create_subscription", {
            state: {
              planType: {
                planName: "any",
                status: false,
              },
            },
          });
          const currentURL = window.location.href;
          const pathAfterAuth = currentURL.split("/auth")[1];
          // console.log(pathAfterAuth);
          /* if (
            pathAfterAuth === "/new-user#" ||
            pathAfterAuth === "/seventhjournal/new-user#" ||
            pathAfterAuth === "/seventhjournal/new-beta-user#" ||
            pathAfterAuth === "/new-beta-user#"
          ) {
            setShouldRenderOutlet(true);
          } else {
            history("/create_subscription", {
              state: {
                planType: {
                  planName: "any",
                  status: false,
                },
              },
            });
          } */
        });
    };

    checkAuthentication();
  }, [history, refresh_session]);
  function directToPaymentUpdate(dynamicPart, refresh_token) {
    const modifiedPath = dynamicPart.includes(
      "auth/paymentupdate/update/refresh_session/"
    )
      ? dynamicPart.replace("/refresh_session/", `/${refresh_token}/`)
      : null;
    if (modifiedPath) {
      history(`/${modifiedPath}`);
    } else {
      return;
    }
  }

  if (isAuthenticated && planSuccess && shouldRenderOutlet) {
    return <Outlet />;
  } else {
    return null;
  }
};

export default Protected;
